import React from "react";
import { useParams } from "react-router-dom";
import { getFeedbackById } from "./api";
const API_URL = process.env.REACT_APP_API_URL;
const fetchConfig = {
  credentials: "include",
  headers: { "Content-Type": "application/json", Accept: "application/json" },
};

const FeedbackView = () => {
  const [feedback, setFeedback] = React.useState(false);
  const [courses, setCourses] = React.useState(false);
  const [user, setUser] = React.useState(false);
  const { id } = useParams();
  React.useEffect(() => {
    const fetchFeedback = async () => {
      const feedback = await getFeedbackById(id);
      setFeedback(feedback.feedback);
      setCourses(feedback.courses);
      setUser(feedback.user);
    };
    fetchFeedback();
  }, []);
  const [reply, setReply] = React.useState("");

  const magicWrite = async () => {
    const metadata = {
      type: "General App Feedback",
      user_name: user.name,
      user_email: user.email,
      feedback: feedback.content,
      support_instructions: reply,
    };
    console.log("Magic Write Metadata:", metadata);
    const res = await fetch(`${API_URL}/support/magic_write`, {
      ...fetchConfig,
      method: "POST",
      body: JSON.stringify({ metadata }),
    });
    console.log("Magic Write Response:", res);
    const data = await res.json();
    console.log("Magic Write Data:", data);
    setReply(data.response);
  };

  const sendEmail = async () => {
    addMessage();
    const req = {
      recipient: user.email,
      subject: "Support Studizy",
      body: reply,
      push_token: feedback.push_token,
    };
    const res = await fetch(`${API_URL}/support/send_email`, {
      ...fetchConfig,
      method: "POST",
      body: JSON.stringify(req),
    });
    const data = await res.json();

    console.log("Email Response:", data);
    handleStatusChange("Handled");
  };

  const addMessage = async () => {
    const newMsg = {
      sender: "Support",
      content: reply,
    };
    setFeedback({
      ...feedback,
      messages: feedback.messages
        ? [
            ...feedback.messages,
            {
              sender: "Support",
              content: reply,
            },
          ]
        : [
            {
              sender: "Support",
              content: reply,
            },
          ],
    });
    const res = await fetch(
      `${API_URL}/support/add_message/feedbacks/${feedback._id}`,
      { ...fetchConfig, method: "POST", body: JSON.stringify(newMsg) }
    );
    setReply("");

    const data = await res.json();
    console.log("Add Message Response:", data);
  };

  const handleStatusChange = async (status) => {
    const res = await fetch(
      `${API_URL}/support/update_status/feedbacks/${feedback._id}/${status}`,
      { ...fetchConfig, method: "GET" }
    );
    const data = await res.json();
    console.log("Status Change Response:", data);
    setFeedback({ ...feedback, status: status });
  };

  return (
    <div>
      <div className="columns">
        <div className="column is-6">
          <div className="is-flex is-justify-content-space-between">
            <h1>
              Feedback view (created_at){" "}
              <span className="tag is-primary">
                {feedback.is_premium ? "Premium User" : "Free User"}
              </span>
              <span className="tag is-secondary ml-2">
                {feedback.push_token ? "PUSH" : "EMAIL"}
              </span>
            </h1>
            {/* Select status dropdown */}
            <div className="select">
              <select
                value={feedback.status || "Unhandled"}
                onChange={(e) => handleStatusChange(e.target.value)}
              >
                <option>Unhandled</option>
                <option>Handled</option>
                <option>Waiting</option>
                <option>Closed</option>
              </select>
            </div>
          </div>
          <h3 className="subtitle is-3">{feedback?.content}</h3>
        </div>
        <div className="column is-6">
          <h1>User ({user?._id})</h1>
          <h3 className="subtitle is-3">
            {user?.name} - {user?.email}
          </h3>
        </div>
      </div>
      <div className="columns">
        <div className="column is-6">
          <div
            style={{
              maxHeight: 500,
              overflowY: "scroll",
              paddingBottom: 50,
            }}
          >
            {feedback.messages &&
              feedback.messages.map((message) => (
                <div
                  className="column box is-7 has-background-grey-dark p-4"
                  style={{
                    float: message.sender === "Support" ? "right" : "left",
                  }}
                >
                  <p className="subtitle is-5">{message.content}</p>
                </div>
              ))}
          </div>
          <textarea
            name=""
            id=""
            className="input"
            style={{ minHeight: 300 }}
            value={reply}
            onChange={(e) => setReply(e.target.value)}
          ></textarea>
          <div className="is-flex is-justify-content-space-between">
            <button
              className="button is-primary mt-3 is-medium"
              onClick={() => magicWrite()}
            >
              Magic Write
            </button>
            <button
              className="button is-grey mt-3 is-medium"
              onClick={() => sendEmail()}
            >
              Send
            </button>
          </div>
        </div>
        <div className="column is-6">
          <h1>Latest courses</h1>
          <div className="columns is-multiline mt-2 pr-5">
            {courses &&
              courses?.map((course) => (
                <div className="column is-6" key={course._id}>
                  <div className="card has-background-grey">
                    <div className="card-content">
                      <h3 className="title is-4">
                        {course.title}
                        <span className="tag">
                          {course.premium ? "PREMIUM" : "Free"}
                        </span>
                      </h3>

                      <a href={course?.origin_url} target="_blank">
                        PDF
                      </a>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackView;
